import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { formatCombo } from 'utils/platform';
import {
  UserDropdownItem, CustomLink, ItemLabel, ShortcutHint
} from './styled';

const DropdownItem = ({
  Modal, action, link, children, badge = undefined, shortcut
}) => {
  const content = (
    <>
      <ItemLabel>{children}</ItemLabel>
      {shortcut && <ShortcutHint>{formatCombo(shortcut)}</ShortcutHint>}
    </>
  );

  const generateDropdownLink = (url, description) => (
    <UserDropdownItem>
      <CustomLink to={ url }>
        {description}
      </CustomLink>
    </UserDropdownItem>
  );

  const generateDropdownModal = (toggleModal, description) => (
    <UserDropdownItem onClick={ toggleModal }>
      {description}
      {badge}
    </UserDropdownItem>
  );

  const generateDropdownAction = (action, description) => (
    <UserDropdownItem onClick={ (e) => action(e) }>{description}</UserDropdownItem>
  );

  let Component;
  if (Modal) {
    Component = generateDropdownModal(Modal.toggleModal, content);
  } else if (action) {
    Component = generateDropdownAction(action, content);
  } else if (link) {
    Component = generateDropdownLink(link, children);
  }

  return Component;
};

DropdownItem.propTypes = {
  Modal: PropTypes.shape({ toggleModal: PropTypes.func }),
  action: PropTypes.func,
  link: PropTypes.string,
  children: PropTypes.node.isRequired,
  shortcut: PropTypes.string
};

DropdownItem.defaultProps = {
  Modal: undefined,
  action: undefined,
  link: undefined,
  shortcut: undefined
};

export default withRouter(DropdownItem);
